var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import { messages as msg } from './messages';
var traverse = function (iterable, langInfo, acc) {
    for (var key in iterable) {
        if (iterable.hasOwnProperty(key)) {
            var accumulator = __spreadArrays(acc);
            accumulator.push(key);
            if (typeof iterable[key] !== 'string') {
                traverse(iterable[key], langInfo, accumulator);
            }
            else {
                var value = iterable[key];
                Object.defineProperty(langInfo, accumulator.join('.'), { value: value });
            }
        }
    }
};
/**
 * Provides mechanism to load language-specific messages for the KendoVue components.
 *
 * @param messages - An iterable object which contains key-value pairs.
 * @param languages - The language to which the messages are associated.
 */
export function loadMessages(messages, language) {
    var langInfo = msg[language] = msg[language] || {};
    traverse(messages, langInfo, []);
}



//////////////////
// WEBPACK FOOTER
// ./~/@progress/kendo-vue-intl/dist/es/Localization/loadMessages.js
// module id = 851
// module chunks = 93